/* Share Grid — header + emoji rows + footer + Copy button. The emoji
   block grows with play (a single ⬜ row before any move; afterward only
   the used rows). Reads marksByGuess and hintPurchasedAt (both signals),
   so updates are automatic. */

import { useState } from "preact/hooks";
import {
  HINT_COST,
  hintPurchasedAt,
  marksByGuess,
  puzzle,
  puzzleNumber,
  statusLine,
} from "../game/state";
import { buildShareText } from "../game/share";
import { ShareButtons } from "./ShareButtons";

export function ShareGrid() {
  const allMarks = marksByGuess.value;
  const p = puzzle.value;
  const text = buildShareText(
    allMarks,
    puzzleNumber.value,
    p.sentence,
    p.maxGuesses,
    hintPurchasedAt.value,
    HINT_COST,
  );
  const lines = text.split("\n");
  const header = lines[0]!;
  const footer = lines[lines.length - 1]!;
  const rows = lines.slice(1, -1);
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      /* Clipboard API may be blocked (insecure context, denied permission).
         Silently leave the button label unchanged rather than misleading. */
    }
  };

  return (
    <section class="sharegrid" aria-label="Share Grid">
      <div class="sharegrid__header">{header}</div>
      <div class="sharegrid__rows" aria-label="Guesses in emoji form">
        {rows.map((row, i) => (
          <div class="sharegrid__row" key={i}>
            {row}
          </div>
        ))}
      </div>
      <div class="sharegrid__hintline">{footer}</div>
      <ShareButtons
        text={text}
        status={`PalinDragon #${puzzleNumber.value} — ${statusLine.value}`}
      />
      <button type="button" class="sharegrid__button" onClick={onCopy}>
        {copied ? "Copied!" : "Copy to Clipboard"}
      </button>
    </section>
  );
}
